import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { InputBase, IconButton, MenuItem, TextField, Button } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import LoadingShort from "../load/loadingShort";
import api from "../services/api";
import apiCNP from "../services/apiCNP";

const SearchEstabelecimento = ({
  setEstabelecimentos,
  setTipo = () => { },       // agora é opcional
  setProvincia = () => { },  // agora é opcional
  setStatus = () => { },     // já estava como opcional
  setDataInicio = () => { },
  setDataFim = () => { },
  placeholder,
  filtroCategorias = true,
  filtroStatus = true,
  dataInicio,
  dataFim,
  provincia,
  tipo,
  status
}) => {
  const location = useLocation();
  const [classeEstabelecimentos, setClasseEstabelecimentos] = useState([]);
  const [provincias, setProvincias] = useState([]);
  const [load, setLoad] = useState(false);
  const [search, setSearch] = useState("");
  // const [status, setStatusState] = useState(""); // novo estado local para status

  const statusList = ["Activo", "Inactivo"];

  useEffect(() => {
    // Buscar categorias de estabelecimentos
    api
      .get("/tipo-estabelecimentos")
      .then((res) => {
        setClasseEstabelecimentos(res.data.tipoEstabelecimentos);
      })
      .catch((err) => console.error("Erro ao carregar categorias:", err));

    // Buscar Provincias para Filtro
    apiCNP
      .get("/Provincias")
      .then((res) => {
        setProvincias(res.data.provincias);
      })
      .catch((err) => console.error("Erro ao carregar categorias:", err));
  }, []);

  const searchEstabelecimento = async (e) => {
    e.preventDefault();
    setEstabelecimentos("");
    setLoad(true);

    try {
      const response = await api.post(`/estabelecimento/search`, {
        search,
        status: status, // usando o status local
      });

      setEstabelecimentos(response.data.estabelecimentos);
    } catch (error) {
      setEstabelecimentos("");
    } finally {
      setLoad(false);
    }
  };

  useEffect(() => {
    // Atualiza o status no componente pai
    setStatus(status); // Aqui estamos passando o status para o componente pai
  }, [status, setStatus]);

  const isReprovadasPage = location.pathname === '/admin/solicitacoes/reprovadas';
  return (
    <form
      onSubmit={searchEstabelecimento}
      style={{
        border: "1px solid #85287e",
        borderRadius: 5,
        display: "flex",
        gap: 10,
        padding: 5,
        flexWrap: "wrap",
        marginBottom: 25,
      }}
    >
      <InputBase
        sx={{ ml: 1, flex: 1 }}
        autoFocus
        placeholder={placeholder}
        inputProps={{ "aria-label": "Filtrar lista" }}
        onChange={(e) => setSearch(e.target.value)}
        value={search}
      />

      <IconButton type="submit" aria-label="search">
        {load ? <LoadingShort /> : <SearchOutlinedIcon />}
      </IconButton>

      {/* Filtro de Categoria */}
      {filtroCategorias &&
        <TextField
          style={{ width: 200 }}
          select
          size="small"
          variant="outlined"
          onChange={(e) =>
            setTipo(e.target.value === "Categorias" ? "" : e.target.value)
          }
          value={tipo}
          label="Categorias"
          // defaultValue="Categorias"
        >
          <MenuItem value="Categorias">Categorias</MenuItem>
          {classeEstabelecimentos?.map((classeEstabelecimento) => (
            <MenuItem
              key={classeEstabelecimento._id}
              value={classeEstabelecimento._id}
            >
              {classeEstabelecimento?.designacao?.toUpperCase()}
            </MenuItem>
          ))}
        </TextField>
      }

      {/* Filtro de Provincias */}
      <TextField
        style={{ width: 200 }}
        select
        size="small"
        variant="outlined"
        onChange={(e) =>
          setProvincia(e.target.value === "Provincias" ? "" : e.target.value)
        }
        value={provincia}
        label="Provincias"
      >
        <MenuItem value="Provincias">Provincias</MenuItem>
        {provincias?.map((provincia) => (
          <MenuItem key={provincia._id} value={provincia.designacao}>
            {provincia.designacao}
          </MenuItem>
        ))}
      </TextField>


      {isReprovadasPage ?
        <>
          <TextField
            style={{ width: 200 }}
            type="date"
            fullWidth
            label="Data Inicial"
            size="small"
            name="dataInicial"
            variant="outlined"
            onChange={(e) => setDataInicio(e.target.value)}
            value={dataInicio}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            style={{ width: 200 }}
            type="date"
            fullWidth
            label="Data Final"
            size="small"
            name="dataFinal"
            variant="outlined"
            onChange={(e) => setDataFim(e.target.value)}
            value={dataFim}
            InputLabelProps={{
              shrink: true,
            }}
          />
        </>
        :
        /* Filtro de Status (fixo) */
        filtroStatus &&
        <TextField
          style={{ width: 150 }}
          select
          size="small"
          label="Estado"
          variant="outlined"
          onChange={(e) => setStatus(e.target.value)}
          value={status}
          // defaultValue="Activo"
        >
          {/* <MenuItem disabled value="Activo">Estado</MenuItem> */}
          {statusList.map((stat, idx) => (
            <MenuItem key={idx} value={stat}>
              {stat}
            </MenuItem>
          ))}
          {/* <MenuItem key={'reprovado'} value={'Reprovado'}>Reprovado</MenuItem> */}
        </TextField>

      }

      <Button
        variant="contained"
        style={{background:'#85287e'}}
        size="small"
        onClick={() => {
          setProvincia('');
          setDataInicio('');
          setDataFim('');
          // setStatusState('');
          setTipo('');
          setSearch('');
        }}
      >
        Limpar Filtro
      </Button>

    </form>
  );
};

export default SearchEstabelecimento;
